module.exports = __webpack_public_path__ + "static/og-image-d98c2dc11b2ac13738f40bb049e204ca.png";